import { GameStatues, IGame } from "./../../entities";
import { provider } from "../../providers";

export interface UpdateGameStatusPayload {
  game: IGame;
  status: GameStatues;
}

export const UpdateGameStatus = async (params: UpdateGameStatusPayload): Promise<IGame> =>
  provider.Request("/games/status", params);
